/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Links_CountInputs */



/**
* | output |
* | --- |
* | "{count} Links" |
*
* @param {Team_Share_Links_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_links_count = /** @type {((inputs: Team_Share_Links_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Links_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} liens`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Links`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} Collegamenti`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} Ссылки`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} Enlaces`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 链接`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} リンク`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} लिंक`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} Links`)
	return /** @type {LocalizedString} */ (`${i?.count} Links`)
});